import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { getPaletteColor, Label, Radio, Text, Flex } from 'pcln-design-system'

const StyledFlex = styled(Flex)`
  align-items: center;
  &:hover {
    ${(props) =>
      props.checked || props.disabled
        ? `cursor: default`
        : `background-color: ${getPaletteColor('background.light')(props)};
      cursor: pointer`};
  }
`

const AutoWidthLabel = styled(Label)`
  width: auto;
`

const SecondaryText = styled(Text.span)`
  flex: 1 1 auto;
`

const toIdCase = (string) => string.replace(/\W/g, '-').toLowerCase()

const RadioButton = (props) => {
  const { checked, dataAutobotElementId, disabled, distance, name, onClick, primaryLabel, secondaryLabel } =
    props

  const radioProps = { checked, disabled }
  const textProps = {
    bold: checked,
    fontWeight: checked ? 'bold' : 'regular',
    color: disabled ? 'text.light' : 'text',
  }
  const id = name && `filter-radio-${toIdCase(name)}`

  return (
    <StyledFlex py={1} {...radioProps} onClick={() => checked || disabled || onClick(props)}>
      <Radio id={id} {...radioProps} data-autobot-element-id={dataAutobotElementId} />
      <AutoWidthLabel htmlFor={id} mx={1} fontSize={0} {...textProps}>
        {primaryLabel ? primaryLabel : name}
      </AutoWidthLabel>

      {distance && (
        <Text ml='auto' fontSize={0} {...textProps}>
          {distance} miles
        </Text>
      )}

      {secondaryLabel && (
        <SecondaryText {...textProps} pt={1} align='right' textAlign='right' fontSize={0}>
          ({secondaryLabel})
        </SecondaryText>
      )}
    </StyledFlex>
  )
}

const defaultProps = {
  checked: false,
  disabled: false,
}

const propTypes = {
  checked: PropTypes.bool,
  dataAutobotElementId: PropTypes.string,
  disabled: PropTypes.bool,
  distance: PropTypes.number,
  name: PropTypes.string,
  onClick: PropTypes.func,
  primaryLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  secondaryLabel: PropTypes.string,
}

RadioButton.propTypes = propTypes
RadioButton.defaultProps = defaultProps

export default RadioButton
